import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NOTIFICATIONS_COMPONENTS_I18N_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, NOTIFICATIONS_COMPONENTS_I18N_KEY, {
  NOTIFICATIONS_LABEL: 'Notifications',
  NOTIFICATIONS_TITLE: 'Latest from Crehana',
  NOTIFICATIONS_COURSES: 'Courses',
  NOTIFICATIONS_COURSE_DETAIL: 'View detail',
  NOTIFICATIONS_FEATURES: 'Updates',
  NOTIFICATIONS_ERROR: 'An error occurred, please try again later.',
  NOTIFICATIONS_RETRY: 'Retry',
  NOTIFICATIONS_EMPTY: 'Soon you will discover all the news we have for you!'
});